import {
    formatValueToInputString,
    parseInputString
} from '../ItemsListTextareaEditor/itemsListTextareaEditor';

export const formatAllowedPageIdsEditorValue = (items: string[]): string => {
    return formatValueToInputString(items, '\n');
};

export const parseAllowedPageIdsEditorValue = (
    inputValue: string
): string[] => {
    return parseInputString(inputValue, '[\\n,]')
        .map(value => value.trim())
        .filter(value => value !== '');
};
